<template>
  <v-container class="container-card">
    <FiltroRelatorios @selectedFilters="filters = $event" />
    <Relatorios :filters="filters" :list="menus" />
  </v-container>
</template>

<script>
import { mapActions } from "vuex";
import FiltroRelatorios from "@/components/comissao/relatorios/FiltroRelatorios";
import Relatorios from "@/components/comissao/relatorios/Relatorios";
export default {
  components: {
    FiltroRelatorios,
    Relatorios
  },

  data() {
    return {
      filters: {},
      menus: [
        {
          title: "Metas",
          icon: "mdi-file-outline",
          reportList: [
            {
              text: "Metas Empresas",
              service: "metaEmpresa",
              permission: 993
            }
          ]
        },
        {
          title: "Realizados",
          icon: "mdi-file-outline",
          reportList: [
            {
              text: "Realizado Empresa",
              service: "realizadoEmpresa",
              permission: 1008
            }
          ]
        }
      ]
    };
  },

  methods: {
    ...mapActions({
      fetchView: "sistema/fetchView"
    })
  },

  mounted() {
    this.fetchView("Relatórios Empresa");
  }
};
</script>

<style></style>
